module.exports = __webpack_public_path__ + "img/pro-m-slider10.f8ce3826.png";